import React, { useEffect, Fragment } from "react";
import Drawer from "@material-ui/core/Drawer";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getBottomTerminalInfo, getBuildLoader, getDeployLoader, getBottomTerminalStatus } from "../../../../store/global/selectors";
import { getBuildLogs } from "../../../../store/global/selectors";
import { handleLogs as handleBuildLogs, handleBottomTerminal, invokePostService, handleSnackBar, closeBottomTerminal, setBuildLoader } from "../../../../store/global/actions";
import Grid from "@material-ui/core/Grid";
import "./index.css";
import Typography from "@material-ui/core/Typography";
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import RemoveIcon from '@material-ui/icons/Remove';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import LinearProgress from '@material-ui/core/LinearProgress';



const AU = require('ansi_up');
const ansi_up = new AU.default();

const BottomTerminal = ({ newUi }) => {

	const dispatch = useDispatch();
	let logs = useSelector(getBuildLogs);
	const terminalInfo = useSelector(getBottomTerminalInfo);
	const treminalType = terminalInfo?.title;
	const [height, setHeight] = useState(100);
	const [open, setOpen] = useState(false);
	const [terminalType, setTerminalType] = useState("buildLogs");
	const [terminalLogs, setTerminalLogs] = useState('Building...');
	const [minimized, setMinimized] = useState(false);
	const isBuilding = useSelector(getBuildLoader);
	const isDeploying = useSelector(getDeployLoader);
	const isTerminalClosed = useSelector(getBottomTerminalStatus);


	useEffect(() => {
		const getTreeElement = document.getElementById("treeWrapperId");
		const getEditElement = document.getElementById("editWrapperId");

		if (getTreeElement) getTreeElement.style.setProperty("margin-bottom", open ? `calc(10.5% + ${height}px)` : "0px", "important");
		if (getEditElement) getEditElement.style.setProperty("margin-bottom", open ? `calc(22.5% + ${height}px)` : "22.5%", "important");
	}, [open, height]);

	const handleOpen = () => setOpen((rev) => !rev);

	const onTerminalOpen = () => {
		handleOpen();
		onIncrement();
	};
	function padTo2Digits(num) {
		return num.toString().padStart(2, '0');
	}

	function formatDate(date) {
		return (
			[
				date.getFullYear(),
				padTo2Digits(date.getMonth() + 1),
				padTo2Digits(date.getDate()),
			].join('-') +
			' ' +
			[
				padTo2Digits(date.getHours()),
				padTo2Digits(date.getMinutes()),
				padTo2Digits(date.getSeconds()),
			].join(':')
		);
	}

	const isLogsAvailable = logs && logs.length;

	/**Converting the time in utc in logs to local date time foramt in 24 hour format*/
	logs = logs.map((element, index) => {
		const UtcDateTimePresent = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/.test(element)
		if (UtcDateTimePresent) {
			const [, log] = element.split(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/);
			const date = element.match(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/)
			const newDateTimeFormat = formatDate(new Date(date[0]))

			// if(index === logs.length -1) setScrollValue(200)

			return `${newDateTimeFormat} ${log}`
		} else {

			return element
		}
	});


	useEffect(() => {
		const lengthCondition = isLogsAvailable > 0;
		// setMinimized(false)
		if (lengthCondition && !isTerminalClosed) {
			if (!open) handleOpen();
			if (height !== 400) setHeight(400);
			else if (isLogsAvailable) setTerminalType("buildLogs");
		}
	}, [isLogsAvailable]);


	useEffect(() => {
		if (terminalInfo?.open && !isTerminalClosed) {
			setOpen(true)
			setHeight(400);
		}
		else {
			setOpen(false);
		}

	}, [terminalInfo]);

	function scrollIntoView() {

		const element = document.getElementById("fakeScreen");

		element.scrollTo({
			top: element.scrollHeight,
			left: 0,
			behavior: 'smooth'
		});
	}

	useEffect(() => {

		// console.log({ logs })

		setTerminalLogs(logs.join('\n'));

		scrollIntoView()

	}, [logs])

	useEffect(() => {
		console.log({ terminalLogs })
	}, [terminalLogs])

	const onDecrement = () => {
		setHeight(100);
	};

	const onIncrement = () => {
		setHeight(400);
	};

	const onClear = () => {
		dispatch(handleBuildLogs([], true));
	};

	const isExpanded = height === 400;

	const handleTerminalChange = (event) => {
		setTerminalType(event.target.value);
	};

	const terminateSimulation = () => {
		dispatch(closeBottomTerminal(true))
		dispatch(setBuildLoader({ status: false }))
		dispatch(invokePostService('terminateSimulation', {}, [], true))
			.then((response) => {
				if (response.status && response.data == 0) {
					console.log("resp111------->", response)
					dispatch(handleSnackBar({ open: true, message: "Simulation terminated", severity: 'success' }));
				}

			})
	}

	const onTerminalClose = () => {

		setOpen(false);
		onClear();
		onDecrement();
		dispatch(handleBottomTerminal(false, ""));
		if (treminalType == "Run Simulation") {
			console.log('for simulation')
			terminateSimulation();
		}
		// terminateSimulation();


	};

	const isBuildLogs = terminalType === "buildLogs";

	const useStyles = makeStyles((theme) => ({
		right: {
			marginLeft: 'auto',
			textAlign: 'right'
		},
		heading: {
			marginLeft: 4
		},
		progressBar: {
			width: '100%',
			'& > * + *': {
				marginTop: theme.spacing(2),
			},
		},
		toolBarHeading: {
			color: '#fff',
			marginTop: 10
		}
	}));

	const classes = useStyles();

	const formatString = (text) => {
		text = ansi_up.ansi_to_html(text)

		if (text.includes('UNUSUAL')) return (`<span class="text-warning">${text}</span?`)

		if (text.includes('ERROR')) return (`<span class="red">${text}</span?`)

		let new_text = text.replace(/\\u001b\[[0-9]{1,2}m/g, '')
			.replace('[success]', '<span class="green">')
			.replace('[/success]', '</span>')
			.replace('[error]', '<span class="red">')
			.replace('[/error]', '</red>');

		return new_text
	}

	return (
		<Fragment>
			<Drawer PaperProps={{ style: { overflow: "visible", borderTop: "1px solid #000", zIndex: 1201, maxHeight: '85%', borderBottom: "1px solid #000" } }} variant="persistent" anchor="bottom" open={open}>

				<div style={{ transition: "height 0.5s ease-in-out", position: "relative" }}>
					<Grid item>

						{isBuildLogs &&
							<div className="bash-holder">
								<div className="fakeMenu">

									<Grid container spacing={1}>
										<Grid item xs={3} className={classes.heading}>
											<Typography className={classes.toolBarHeading}>{terminalInfo?.title}</Typography>
										</Grid>

										<Grid item xs={6} className={classes.right}>

											{minimized == false && <IconButton onClick={e => setMinimized(true)}>
												<Tooltip title="Minimize build terminal">
													<RemoveIcon size={'small'} button style={{ color: 'white' }} />
												</Tooltip>
											</IconButton>}

											{minimized && <IconButton onClick={e => setMinimized(false)}>
												<Tooltip title="Expand build terminal">
													<ExpandLessIcon size={'small'} button style={{ color: 'white' }} />
												</Tooltip>
											</IconButton>}

											<IconButton onClick={onTerminalClose}>
												<Tooltip title={treminalType == "Run Simulation" ? "Terminate simulation" : "Close build terminal"}>
													<CloseOutlinedIcon size={'small'} button style={{ color: 'white' }} />
												</Tooltip>
											</IconButton>

										</Grid>
									</Grid>

									{(isBuilding || isDeploying) && <div className={classes.progressBar}>
										<LinearProgress id="linear-progress" />
									</div>
									}

								</div>

								<div id="fakeScreen" className="fakeScreen" style={{ height: !minimized ? 600 : 0, overflow: 'auto', paddingTop: !minimized ? 10 : 0, paddingBottom: !minimized ? 20 : 0 }}>

									{logs.filter(log => log != '').map(log => <p className="line12" dangerouslySetInnerHTML={{ __html: formatString(log) }}></p>)}
									<p className="line12"><span className="cursor1">_</span></p>

								</div>
							</div>

						}

					</Grid>
				</div>




			</Drawer>
		</Fragment>
	);
};

export default BottomTerminal;


